/* eslint-disable react/prop-types */
import IcoMoon from "react-icomoon";
import iconSet from "../../selection.json";

const Icon = ({ icon, color, className, style }) => {
  return (
    <IcoMoon
      icon={icon}
      color={color}
      iconSet={iconSet}
      className={className}
      style={style}
    />
  );
};

export default Icon;
